import { Component, HostBinding, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
@Component({
    selector: "app-checkbox",
    template: `
          <div class="row">
            <div class="col-12 demo-full-width margin-top" [formGroup]="group" >
                <mat-checkbox [formControlName]="field.name">{{field.label}}</mat-checkbox>
            </div>
        </div>
`,
    styles: []
})
export class CheckboxComponent implements OnInit {
    field: FieldConfig;
    group: FormGroup;
    @HostBinding('class') class = '';
    constructor() {
    }
    ngOnInit() {
      this.class = this.field.claseGrillaBootstrap;
    }
}
